// Chakra imports
import { Flex, Heading, Link, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
// Custom components
// Assets
import illustration from 'assets/img/banner.jpg';
import { ReactComponent as Logo } from 'assets/img/logo.svg';

function DefaultAuth(props: { children: JSX.Element | string }) {
    const { children } = props;
    // Chakra color mode
    return (
        <div className="auth-layout">
            <div className="auth-layout__main">
                <div className="auth-main-container">{children}</div>
                <Text fontSize="14px" fontWeight="500" color="gray.400" textAlign="center" mt="40px">
                    © 2024 Lead Pulse. All Rights Reserved. Made with love by Agexa!
                </Text>
            </div>
            <div className="auth-layout__second">
                <Flex
                    bg={`url(${illustration})`}
                    bgSize="cover"
                    height="100%"
                    bgPosition="center"
                    borderRadius="16px"
                    flexDirection="column"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="32px"
                >
                    <Logo />
                    <Flex alignItems="center" flexDirection="column" color="white">
                        <Heading fontSize="40px" lineHeight="1.4" letterSpacing="-1.6px" textAlign="center">
                            Your all-in-one unique tool for managing & boosting lead conversion!
                        </Heading>
                        <Text
                            fontSize="14px"
                            fontWeight="500"
                            lineHeight="1.4"
                            opacity="0.7"
                            textAlign="center"
                            mt="40px"
                            mb="8px"
                        >
                            Learn more about Lead Pulse on
                        </Text>
                        <Link target="_blank" href="#" fontSize="24px" lineHeight="1" fontWeight="700">
                            leadpulse.com
                        </Link>
                    </Flex>
                    <Flex gap="40px" justifyContent="center" color="white">
                        <Link fontSize="14px" fontWeight="500" lineHeight="1.4">
                            Affiliate
                        </Link>
                        <Link fontSize="14px" fontWeight="500" lineHeight="1.4">
                            License
                        </Link>
                        <Link fontSize="14px" fontWeight="500" lineHeight="1.4">
                            Terms of Use
                        </Link>
                        <Link fontSize="14px" fontWeight="500" lineHeight="1.4">
                            Blog
                        </Link>
                    </Flex>
                </Flex>
            </div>
        </div>
        // <Flex position="relative" h="max-content">
        //     <Flex
        //         h={{
        //             sm: 'initial',
        //             md: 'unset',
        //             lg: '100vh',
        //             xl: '97vh',
        //         }}
        //         w="100%"
        //         maxW={{ md: '66%', lg: '1313px' }}
        //         mx="auto"
        //         pt={{ sm: '50px', md: '0px' }}
        //         px={{ lg: '30px', xl: '0px' }}
        //         ps={{ xl: '70px' }}
        //         justifyContent="start"
        //         direction="column"
        //     >
        //         {/* <NavLink
        // 			to='/admin'
        // 			style={() => ({
        // 				width: 'fit-content',
        // 				marginTop: '40px'
        // 			})}>
        // 			<Flex align='center' ps={{ base: '25px', lg: '0px' }} pt={{ lg: '0px', xl: '0px' }} w='fit-content'>
        // 				<Icon as={FaChevronLeft} me='12px' h='13px' w='8px' color='secondaryGray.600' />
        // 				<Text ms='0px' fontSize='sm' color='secondaryGray.600'>
        // 					Back to Simmmple
        // 				</Text>
        // 			</Flex>
        // 		</NavLink> */}
        //         {children}
        //         <Box
        //             display={{ base: 'none', md: 'block' }}
        //             h="100%"
        //             minH="100vh"
        //             w={{ lg: '50vw', '2xl': '44vw' }}
        //             position="absolute"
        //             right="0px"
        //         >
        //             <Flex
        //                 bg={`url(${illustrationBackground})`}
        //                 justify="center"
        //                 align="end"
        //                 w="100%"
        //                 h="100%"
        //                 bgSize="cover"
        //                 bgPosition="50%"
        //                 position="absolute"
        //                 borderBottomLeftRadius={{ lg: '120px', xl: '200px' }}
        //             />
        //         </Box>
        //         <Footer />
        //     </Flex>
        //     <FixedPlugin />
        // </Flex>
    );
}
// PROPS

DefaultAuth.propTypes = {
    illustrationBackground: PropTypes.string,
    image: PropTypes.any,
};

export default DefaultAuth;
